// extracted by mini-css-extract-plugin
module.exports = {"cms":"CMS-module--cms--tuirR"};